

.stats {

    margin-top: 30px;
    display: inline-flex;
    color: var(--beigedarker) !important;
    gap: 1rem;
    z-index: 3;
    position: relative;
    width: 100%;

    & > span
    {
      background: white;
      position: relative;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      border-radius: 14px;
      padding: 0 8px;

      & > img {
        width: 14px;
        height: 14px;
      }
      & > span
      {
        margin-left: 6px;
      }
    }
}